"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localizeMoney = exports.observeRoundedMoney = exports.roundMoney = exports.validateMoneyRound = void 0;
const validateMoneyRound = (v) => {
    if (typeof v !== 'string' && typeof v !== 'number')
        return false;
    let value = v;
    if (typeof value === 'string') {
        value = Number.parseFloat(value);
        if (isNaN(value))
            return false;
    }
    return value * 20 === Math.trunc(value * 20);
};
exports.validateMoneyRound = validateMoneyRound;
/**
 * Round to 0.05. Same as API-implementation
 */
const roundMoney = (value) => {
    const r = Number(value.toFixed(8));
    return Number((Math.ceil(r * 20) / 20).toFixed(2));
};
exports.roundMoney = roundMoney;
/** Check 0.05 rounding. Log error if not rounded */
const observeRoundedMoney = (value, hint) => {
    if (value !== (0, exports.roundMoney)(value)) {
        console.error(`Money is not rounded: ${value}`, hint);
    }
    return value;
};
exports.observeRoundedMoney = observeRoundedMoney;
const localizeMoney = (value = 0, locale, hint) => {
    // German is only available in Switzerland. There are no other clients of Malesia.
    const fixedLocale = locale === 'de' ? 'de-CH' : locale;
    const rounded = (0, exports.observeRoundedMoney)(value, `localizeMoney: ${hint}`);
    return rounded.toLocaleString(fixedLocale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};
exports.localizeMoney = localizeMoney;
//# sourceMappingURL=roundMoney.js.map